// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-title {
  font-weight: 700;
  color: #333;
}

/* .oee-fontsize-30{
    font-size: 30px;
} */

.kpi-card-info1 {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.kpi-card-info1:hover {
  transform: translateY(-5px);
}

.chart-card {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease-in-out;
}

.chart-card:hover {
  transform: translateY(-5px);
}

.chart-card h5 {
  font-size: 30px;
  font-weight: 600;
  color: #333;
}

.apexcharts-canvas {
  margin-top: -15px;
}

@media (max-width: 768px) {
  .chart-card {
    margin-bottom: 20px;
  }
}


.kpi-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid var(--kpi-color); /* Dynamic color */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.kpi-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.kpi-image {
  width: auto;
  height: 75px;
  object-fit: contain;
}

h5 {
  font-size: 16px;
  color: #555;
  margin-bottom: 4px;
}

.oee-fontsize-30 {
  font-size: 30px;
  color: #222;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/reports/OeeDashboard/OeeDashboard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yCAAyC,EAAE,kBAAkB;EAC7D,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".dashboard-title {\n  font-weight: 700;\n  color: #333;\n}\n\n/* .oee-fontsize-30{\n    font-size: 30px;\n} */\n\n.kpi-card-info1 {\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n}\n\n.kpi-card-info1:hover {\n  transform: translateY(-5px);\n}\n\n.chart-card {\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s ease-in-out;\n}\n\n.chart-card:hover {\n  transform: translateY(-5px);\n}\n\n.chart-card h5 {\n  font-size: 30px;\n  font-weight: 600;\n  color: #333;\n}\n\n.apexcharts-canvas {\n  margin-top: -15px;\n}\n\n@media (max-width: 768px) {\n  .chart-card {\n    margin-bottom: 20px;\n  }\n}\n\n\n.kpi-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-bottom: 4px solid var(--kpi-color); /* Dynamic color */\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.kpi-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n.kpi-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.kpi-image {\n  width: auto;\n  height: 75px;\n  object-fit: contain;\n}\n\nh5 {\n  font-size: 16px;\n  color: #555;\n  margin-bottom: 4px;\n}\n\n.oee-fontsize-30 {\n  font-size: 30px;\n  color: #222;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
